/// <amd-module name="typeahead/core/OnFocusSuggester" />

import {ISuggesterConfig, SuggesterId, SuggestionsAggregator} from "typeahead/core/SuggestionsAggregator";

export class OnFocusSuggester extends SuggestionsAggregator {

    public getRecentHistorySuggesterConfig(): ISuggesterConfig {
        return {
            isEnabled: true,
            rank: 3,
        };
    }

    public getFlightBookingSuggesterConfig(): ISuggesterConfig {
        return {
            isEnabled: true,
            rank: 2,
        };
    }

    public getCurrentLocationSuggesterConfig(): ISuggesterConfig {
        return {
            isEnabled: true,
            rank : 1,
        };
    }

    public getId(): SuggesterId {
        return SuggesterId.OnFocusSuggester;
    }
}
